import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the reference company api
 */
export class ReferenceCompanyService extends BaseService {

	constructor() {	
		super();
	}
	
	async getReferenceCompanies(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/reference-companies' + params);		
		return data;		
	}
	
	async getRefCompany(refCompanyId) {
		var data = await this.makeGETRequest('/api/resource/reference-companies/' + refCompanyId);		
		return data;		
	}
	
	async saveRefCompany(refcompany, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/reference-companies/' + refcompany.refCompanyId, refcompany);
		} else {
			saved = await this.makePOSTRequest('/api/resource/reference-companies', refcompany);
		}
		return saved;		
	}	
	
	async updateRefCompanyStatus(refCompanyId, active) {
		var data;
		if (active) {
			data = await this.makePUTRequest('/api/resource/reference-companies/' + refCompanyId + '/activate');		
		} else {
			data = await this.makePUTRequest('/api/resource/reference-companies/' + refCompanyId + '/inactivate');	
		}		
		return data;		
	}
	
}
